import { createAsyncThunk } from '@reduxjs/toolkit'
import apiClient from '../../../services/axois'
import { API_ROUTES } from '../../../utility/api.routes'
import { toast } from 'react-toastify'

export const getFacultyDashboard = createAsyncThunk(
  'facultyDashboard/getFacultyDashboard',
  async ({ facultyId, startDate, endDate }) => {
    let url
    try {
      if (startDate) {
        url = `${API_ROUTES.FACULTY.GET_FACULTY_DASHBOARD(facultyId)}?startDate=${startDate}&&endDate=${endDate}`
      } else {
        url = `${API_ROUTES.FACULTY.GET_FACULTY_DASHBOARD(facultyId)}`
      }
      const response = await apiClient.get(url)
      // toast.success(response.data.message)
      return response?.data?.result
    } catch (error) {
      toast.error(error.response.data.message)
      throw error
    }
  },
)

export const getFacultyDashboardPayment = createAsyncThunk('facultyDashboard/getFacultyDashboardPayment', async (facultyId) => {
    try {
      const url = API_ROUTES.FACULTY.GET_FACULTY_DASHBOARD_PAYMENT(facultyId)
      const response = await apiClient.get(url)
      return response?.data?.result
    } catch (error) {
      toast.error(error.response.data.message)
      throw error
    }
  },
)
